import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { tap } from 'rxjs';
import { DomService } from '../../../shared/services';
import { listenForLargeScreen } from '../../../shared/utils';

@UntilDestroy()
@Component({
  selector: 'app-mobile-layout',
  templateUrl: './mobile-layout.component.html',
  styleUrls: ['./mobile-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [RouterOutlet],
})
export class MobileLayoutComponent implements OnInit {
  private dom = inject(DomService);

  ngOnInit(): void {
    listenForLargeScreen()
      .pipe(
        tap(isLarge => {
          if (isLarge) {
            this.dom.window?.history.back();
          }
        }),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
